// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-box .ver-count-input[data-v-5ebedbe6] {\n  width: 100%;\n}\n.dialog-box[data-v-5ebedbe6]  .el-dialog {\n  margin-top: 30vh !important;\n  width: 410px;\n}\n.flex-right[data-v-5ebedbe6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}", ""]);
// Exports
module.exports = exports;
